/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_TitleInputs */

const en_messages_title = /** @type {(inputs: Messages_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messages`)
};

const he_messages_title = /** @type {(inputs: Messages_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הודעות`)
};

/**
* | output |
* | --- |
* | "Messages" |
*
* @param {Messages_TitleInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const messages_title = /** @type {((inputs?: Messages_TitleInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_TitleInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_title(inputs)
	return he_messages_title(inputs)
});